import { useState } from "react";
import { motion } from "framer-motion";
import { LayoutDashboard, TrendingUp, Receipt, ClipboardList, PiggyBank, Target, Calculator, Sparkles, Cake, ShieldCheck, Hourglass } from "lucide-react";
import JaminanTab from "@/components/duitku/JaminanTab";
import KontrakTab from "@/components/duitku/KontrakTab";
import BirthdayTab from "@/components/duitku/BirthdayTab";
import Overview from "@/components/duitku/Overview";
import IncomeTab from "@/components/duitku/IncomeTab";
import ExpenseTab from "@/components/duitku/ExpenseTab";
import BudgetTab from "@/components/duitku/BudgetTab";
import SavingsTab from "@/components/duitku/SavingsTab";
import GoalsTab from "@/components/duitku/GoalsTab";
import SimulatorTab from "@/components/duitku/SimulatorTab";
import InsightsTab from "@/components/duitku/InsightsTab";

const TABS = [
  { id: "overview", label: "Ringkasanku", icon: LayoutDashboard, C: Overview },
  { id: "income", label: "Pemasukanku", icon: TrendingUp, C: IncomeTab },
  { id: "expense", label: "Pengeluaranku", icon: Receipt, C: ExpenseTab },
  { id: "budget", label: "Anggaranku", icon: ClipboardList, C: BudgetTab },
  { id: "birthday", label: "Ultah Temanku", icon: Cake, C: BirthdayTab },
  { id: "savings", label: "Tabunganku", icon: PiggyBank, C: SavingsTab },
  { id: "jaminan", label: "Uang Jaminan", icon: ShieldCheck, C: JaminanTab },
  { id: "kontrak", label: "Habis Kontrak", icon: Hourglass, C: KontrakTab },
  { id: "goals", label: "Impianku", icon: Target, C: GoalsTab },
  { id: "simulator", label: "Simulasi Nabung", icon: Calculator, C: SimulatorTab },
  { id: "ai-insights", label: "Saran Baby Monster", icon: Sparkles, C: InsightsTab },
];

export default function Duitku() {
  const [tab, setTab] = useState("overview");
  const Active = TABS.find((t) => t.id === tab).C;
  return (
    <div className="space-y-5">
      <div>
        <p className="text-sm text-pink-500 font-medium">Uangku, catatanku</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">Duitku</h1>
      </div>
      <div className="flex gap-2 overflow-x-auto md:flex-wrap md:overflow-visible no-scrollbar -mx-4 px-4 md:mx-0 md:px-0 pb-1">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button key={id} onClick={() => setTab(id)} className={`chip ${tab === id ? "chip-on" : "chip-off"}`} data-testid={`duitku-tab-${id}`}>
            <Icon className="w-4 h-4" /> {label}
          </button>
        ))}
      </div>
      <motion.div key={tab} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25 }}>
        <Active />
      </motion.div>
    </div>
  );
}
